import { render, staticRenderFns } from "./CustomTabs.vue?vue&type=template&id=fca54c30&scoped=true&"
import script from "./CustomTabs.vue?vue&type=script&lang=ts&"
export * from "./CustomTabs.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTabs.vue?vue&type=style&index=0&id=fca54c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca54c30",
  null
  
)

export default component.exports